<!--begin::Subheader-->
<div [ngClass]="subheaderContainerClasses" class="d-flex align-items-center justify-content-center flex-wrap flex-sm-nowrap">
  <!--begin::Info-->
  <div class="d-flex align-items-center flex-wrap mr-1">
    <!--begin::Page Heading-->
    <div class="d-flex align-items-baseline mr-5">
      <ng-container *ngIf="title">
        <!--begin::Page Title-->
        <h5 class="text-dark font-weight-bold my-2 mr-5">
          {{title}}
        </h5>
      </ng-container>
      <!--end::Page Title-->

      <!--begin::Breadcrumb-->
      <ng-container *ngIf="desc">
        <ul class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
          <li class="breadcrumb-item"><a href="#"><i class="flaticon2-shelter text-muted icon-1x"></i></a></li>
          <li class="breadcrumb-item">
            <a [routerLink]="desc.link" class="text-muted">
              {{desc.title}}
            </a>
          </li>
        </ul>
      </ng-container>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page Heading-->
  </div>
  <!--end::Info-->
</div>
<!--end::Subheader-->
